var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "checkout-view" },
    [
      !_vm.initialBuyerData && !_vm.isRequesting
        ? [
            _c("div", { staticClass: "checkout__info" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("checkout.info.notLoggedIn")) +
                  "\n      "
              ),
              _c(
                "a",
                { staticClass: "button", attrs: { href: _vm.loginPageUrl } },
                [_vm._v(_vm._s(_vm.$t("global.links.toLogin")))]
              ),
            ]),
          ]
        : !_vm.isSubmitting && _vm.postCheckout
        ? [
            _c("div", { staticClass: "checkout__info" }, [
              !_vm.isInactiveAndRefreshTimer
                ? _c("p", [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("checkout.info.noOrderActiveTimer")) +
                        "\n      "
                    ),
                  ])
                : _c("p", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$t("checkout.info.noOrderInactiveTimer")
                      ),
                    },
                  }),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "button button-inverted",
                  attrs: { href: _vm.ticketShopUrl },
                },
                [_vm._v(_vm._s(_vm.$t("global.links.toTicketShop")))]
              ),
            ]),
          ]
        : !_vm.isSubmitting &&
          _vm.currentOrder.orderItems.length === 0 &&
          !_vm.isRequesting
        ? [
            _c("div", { staticClass: "checkout__info" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("checkout.info.emptyShoppingCart")) +
                  "\n      "
              ),
              _c(
                "a",
                {
                  staticClass: "button button-inverted",
                  attrs: { href: _vm.ticketShopUrl },
                },
                [_vm._v(_vm._s(_vm.$t("global.links.toTicketShop")))]
              ),
            ]),
          ]
        : !_vm.isSubmitting && _vm.mustOrderWithLogin && _vm.isGuestOrder
        ? [
            _c("div", { staticClass: "checkout__info" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("checkout.info.guestLogin")) +
                  "\n      "
              ),
              _c(
                "a",
                {
                  staticClass: "button button-inverted",
                  attrs: { href: _vm.loginPageUrl },
                },
                [_vm._v(_vm._s(_vm.$t("global.links.toLogin")))]
              ),
            ]),
          ]
        : !_vm.isSubmitting &&
          _vm.mustOrderAsGuest &&
          !_vm.mustOrderWithLogin &&
          !_vm.isGuestOrder
        ? [
            _c("div", { staticClass: "checkout__info" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("checkout.info.guestOnly")) +
                  "\n      "
              ),
              _c(
                "a",
                {
                  staticClass: "button button-inverted",
                  attrs: { href: _vm.loginPageUrl },
                },
                [_vm._v(_vm._s(_vm.$t("global.links.toLogin")))]
              ),
            ]),
          ]
        : _vm.showQuantityError
        ? [
            _c(
              "div",
              { staticClass: "checkout__info" },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.$t("checkout.info.quantityError.fromTheProduct", {
                        product:
                          _vm.invalidProductQuantityProduct.descriptionWebShop,
                      })
                    ) +
                    "\n      "
                ),
                _vm.isQuantityInvalidTooMany
                  ? [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.$t("checkout.info.quantityError.tooMany")
                          ) +
                          "\n      "
                      ),
                    ]
                  : [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("checkout.info.quantityError.few")) +
                          "\n      "
                      ),
                    ],
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("checkout.info.quantityError.ordered")) +
                    "\n      " +
                    _vm._s(_vm.$t("checkout.info.quantityError.hint")) +
                    "\n      "
                ),
                _c("br"),
                _vm._v(" "),
                _c("strong", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("checkout.info.quantityError.minimumOrderQuantity")
                    )
                  ),
                ]),
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.invalidProductQuantityProduct.minOrderQuantity) +
                    "\n      "
                ),
                _c("strong", [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$t(
                          "checkout.info.quantityError.maximumOrderQuantity"
                        )
                      ) +
                      "\n      "
                  ),
                ]),
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.invalidProductQuantityProduct.maxOrderQuantity
                        ? _vm.invalidProductQuantityProduct.maxOrderQuantity
                        : "-"
                    ) +
                    "\n      "
                ),
                _c(
                  "a",
                  {
                    staticClass: "button button-inverted",
                    attrs: { href: _vm.ticketShopUrl },
                  },
                  [_vm._v(_vm._s(_vm.$t("global.links.toShoppingCart")))]
                ),
              ],
              2
            ),
          ]
        : [
            _vm.isRequesting
              ? [_c("spinner")]
              : [
                  _c("div", { attrs: { id: "paypalpayments" } }),
                  _vm._v(" "),
                  _c("div", { staticClass: "wizard-navigation__background" }),
                  _vm._v(" "),
                  _c(
                    "form-wizard",
                    {
                      ref: "formWizard",
                      staticClass: "checkout__wizard clr",
                      attrs: {
                        "start-index": _vm.currentIndex,
                        "back-button-text": _vm.$t("global.links.back"),
                        color: "#ffffff",
                        "error-color": "red",
                        "finish-button-text": _vm.$t("global.links.lock"),
                        "next-button-text": _vm.$t("global.links.continue"),
                        stepSize: "sm",
                        subtitle: _vm.$t("global.formWizzard.subtitle"),
                        title: _vm.$t("global.formWizzard.title"),
                      },
                      on: { "on-change": _vm.updateCurrentIndex },
                      scopedSlots: _vm._u([
                        {
                          key: "footer",
                          fn: function (props) {
                            return [
                              _vm.isSubmitting || _vm.loading
                                ? [_c("spinner")]
                                : [
                                    _c(
                                      "div",
                                      { staticClass: "wizard-footer-left" },
                                      [
                                        props.activeTabIndex > 0 &&
                                        !props.isLastStep
                                          ? [
                                              _c(
                                                "wizard-button",
                                                {
                                                  nativeOn: {
                                                    click: function ($event) {
                                                      return _vm.updatePageRefreshedAndCallToStepFunction(
                                                        props.activeTabIndex - 1
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "a",
                                                    { staticClass: "button" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "global.links.back"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          : _vm._e(),
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "wizard-footer-right" },
                                      [
                                        !props.isLastStep
                                          ? [
                                              !_vm.currentOrder.buyerData ||
                                              _vm.currentOrder.buyerData
                                                .paymentOption !== "paypal" ||
                                              props.activeTabIndex !== 3
                                                ? [
                                                    _c(
                                                      "wizard-button",
                                                      {
                                                        staticClass:
                                                          "wizard-footer-right button",
                                                        class: {
                                                          "button--disabled":
                                                            !_vm.isCurrentStepValid,
                                                        },
                                                        style:
                                                          props.fillButtonStyle,
                                                        nativeOn: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.handleClick(
                                                              props.activeTabIndex +
                                                                1
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        props.activeTabIndex !==
                                                        _vm.reviewStep
                                                          ? [
                                                              _vm._v(
                                                                "\n                      " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "global.links.continue"
                                                                    )
                                                                  ) +
                                                                  "\n                    "
                                                              ),
                                                            ]
                                                          : [
                                                              _vm.cart.sum > 0
                                                                ? [
                                                                    _vm._v(
                                                                      "\n                        " +
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "global.links.orderWithObligationToPay"
                                                                          )
                                                                        ) +
                                                                        "\n                      "
                                                                    ),
                                                                  ]
                                                                : [
                                                                    _vm._v(
                                                                      "\n                        " +
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "global.links.requestTickets"
                                                                          )
                                                                        ) +
                                                                        "\n                      "
                                                                    ),
                                                                  ],
                                                            ],
                                                      ],
                                                      2
                                                    ),
                                                  ]
                                                : [
                                                    _c("div", {
                                                      ref: "paypalButtonContainer",
                                                      class: {
                                                        "display-none":
                                                          !_vm.isCurrentStepValid,
                                                      },
                                                      attrs: {
                                                        id: "paypal-buttons-container",
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    !_vm.isCurrentStepValid
                                                      ? _c("p", {
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              _vm.$t(
                                                                "global.paypal.paypalDisabled"
                                                              )
                                                            ),
                                                          },
                                                        })
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.missingDataProtection
                                                      ? [
                                                          _c(
                                                            "button",
                                                            {
                                                              staticClass:
                                                                "button",
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.$refs.consentModal.showModal()
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "global.links.continue"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      : _vm._e(),
                                                  ],
                                            ]
                                          : [
                                              _c(
                                                "wizard-button",
                                                {
                                                  staticClass:
                                                    "wizard-footer-right finish-button",
                                                  style: props.fillButtonStyle,
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "global.links.done"
                                                        )
                                                      ) +
                                                      "\n                "
                                                  ),
                                                ]
                                              ),
                                            ],
                                      ],
                                      2
                                    ),
                                  ],
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c(
                        "tab-content",
                        {
                          attrs: {
                            "before-change": _vm.validatePersonalization,
                            title: _vm.$t("checkout.personalisation.title"),
                          },
                        },
                        [
                          _c("h3", [
                            _vm._v(
                              _vm._s(_vm.$t("checkout.personalisation.title"))
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "checkout-form__container" },
                            [
                              !_vm.hasItemsWithRegistrationRequired
                                ? [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "checkout-form__group checkout-form__group--paddingMobile",
                                      },
                                      [
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "checkout.personalisation.hintNoRegistrationRequired"
                                              )
                                            )
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                : _vm.hasSelectedForPersonalUse
                                ? [
                                    !_vm.personalizationValid
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "checkout-form__error",
                                          },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "global.errorMessages.unfinishedForm"
                                                  )
                                                ) +
                                                "\n              "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.isMounted
                                      ? [
                                          _c("customer-form", {
                                            key: "personalization",
                                            ref: "personalizationForm",
                                            attrs: {
                                              context: "personalization",
                                              "customer-data-d-t-o":
                                                _vm.personalizationDTO,
                                              "inventory-url": _vm.inventoryUrl,
                                              "required-fields": [],
                                              "disabled-fields": [
                                                "salutation",
                                                "title",
                                                "firstName",
                                                "lastName",
                                                "email",
                                                "addressType",
                                                "company",
                                                "additionalInformation",
                                                "street",
                                                "houseNr",
                                                "zip",
                                                "city",
                                                "country",
                                                "state",
                                              ],
                                            },
                                            on: {
                                              update:
                                                _vm.updatePersonalizationDTO,
                                            },
                                          }),
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.hasEvents &&
                                    _vm.hasSurveys &&
                                    _vm.isBesucher &&
                                    !_vm.hideSurvey
                                      ? [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "checkout-form__group",
                                            },
                                            [_c("hr")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "h3",
                                            { staticClass: "h3 h3--medium" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "checkout.personalisation.visitorSurvey.headline"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "checkout-form__group",
                                            },
                                            [
                                              _vm._l(
                                                _vm.events,
                                                function (event) {
                                                  return [
                                                    _vm.hasSurvey(event)
                                                      ? [
                                                          _c(
                                                            "visitor-survey-component",
                                                            {
                                                              key: event.id,
                                                              ref:
                                                                "survey" +
                                                                event.id,
                                                              refInFor: true,
                                                              attrs: {
                                                                initial:
                                                                  _vm.getInitialSurveyData(
                                                                    event
                                                                  ),
                                                                event: event,
                                                                "inventory-url":
                                                                  _vm.inventoryUrl,
                                                                "visitor-survey":
                                                                  event.visitorSurvey,
                                                                "order-items":
                                                                  _vm.cart.order
                                                                    .orderItems,
                                                                "validate-survey":
                                                                  _vm.validateSurvey,
                                                              },
                                                              on: {
                                                                update:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.updateSurveyData(
                                                                      $event,
                                                                      event
                                                                    )
                                                                  },
                                                                hideSurvey:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    _vm.hideSurvey = true
                                                                  },
                                                              },
                                                            }
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "checkout-form__group",
                                                            },
                                                            [_c("hr")]
                                                          ),
                                                        ]
                                                      : _vm._e(),
                                                  ]
                                                }
                                              ),
                                            ],
                                            2
                                          ),
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "checkout-form__group checkout-form__group--paddingMobile",
                                      },
                                      [
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "checkout-form__group--requiredInfo",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "global.forms.requiredInfo"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                : [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "checkout-form__group checkout-form__group--paddingMobile",
                                      },
                                      [
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "checkout.personalisation.hintNoTickets"
                                              )
                                            )
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ],
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "checkout-form__changeSelection",
                                },
                                [
                                  _c("personal-use-modal", {
                                    ref: "personalUseModal",
                                    attrs: {
                                      "modal-trigger-text": _vm.$t(
                                        "checkout.personalisation.changeUse"
                                      ),
                                      "inventory-url": _vm.inventoryUrl,
                                      "ticket-shop-url": _vm.ticketShopUrl,
                                      "checkout-url": _vm.checkoutUrl,
                                      isModalTriggerCTA: false,
                                      "submit-cb": _vm.onPersonalUseChange,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            2
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("tab-content", { attrs: { title: "VVS" } }, [
                        _c(
                          "div",
                          { staticClass: "checkout-form__container" },
                          [
                            _vm.anyProductHasPubTransIncluded
                              ? [
                                  _c(
                                    "div",
                                    { staticClass: "publicTransport__header" },
                                    [
                                      _c("h3", [_vm._v("VVS")]),
                                      _vm._v(" "),
                                      _c("Vvs"),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  !_vm.pubTransValid
                                    ? _c(
                                        "div",
                                        { staticClass: "checkout-form__error" },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.$t(
                                                  "global.errorMessages.unfinishedForm"
                                                )
                                              ) +
                                              "\n              "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("order-public-transport-modal", {
                                    ref: "pubTransComponent",
                                    attrs: {
                                      "modal-trigger-text": _vm.$t(
                                        "checkout.personalisation.publicTransport.select"
                                      ),
                                      "inventory-url": _vm.inventoryUrl,
                                      "initial-pub-trans-configs":
                                        _vm.personalizationDTO
                                          .publicTransportConfigs,
                                    },
                                    on: {
                                      updateAdditionalOrderItemConfig:
                                        _vm.updateAdditionalOrderItemConfig,
                                    },
                                  }),
                                ]
                              : [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "checkout-form__group checkout-form__group--paddingMobile",
                                    },
                                    [
                                      _c("p", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "checkout.personalisation.publicTransport.hintNoPublicTransport"
                                            )
                                          )
                                        ),
                                      ]),
                                    ]
                                  ),
                                ],
                          ],
                          2
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "tab-content",
                        {
                          attrs: {
                            "before-change": _vm.validatePayment,
                            title: _vm.$t("checkout.payment.title"),
                          },
                        },
                        [
                          _vm.cart.sum > 0.0
                            ? [
                                _c("h3", [
                                  _vm._v(
                                    _vm._s(_vm.$t("checkout.payment.hint"))
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "checkout-form__container" },
                                  [
                                    _vm.showPaymentErrors
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "checkout-form__error",
                                          },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "global.errorMessages.unfinishedForm"
                                                  )
                                                ) +
                                                "\n              "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "paymentOptions" },
                                      [
                                        _vm._l(
                                          _vm.paymentChoices,
                                          function (payment) {
                                            return [
                                              !payment.disabled
                                                ? _c(
                                                    "div",
                                                    { staticClass: "option" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "option_selection",
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "option__radio",
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "checkout-form__field checkout-form__field--radio",
                                                                },
                                                                [
                                                                  _c(
                                                                    "label",
                                                                    {
                                                                      attrs: {
                                                                        for:
                                                                          "payment-" +
                                                                          payment.value,
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "input",
                                                                        {
                                                                          directives:
                                                                            [
                                                                              {
                                                                                name: "model",
                                                                                rawName:
                                                                                  "v-model",
                                                                                value:
                                                                                  _vm
                                                                                    .personalizationDTO
                                                                                    .paymentOption,
                                                                                expression:
                                                                                  "personalizationDTO.paymentOption",
                                                                              },
                                                                            ],
                                                                          attrs:
                                                                            {
                                                                              id:
                                                                                "payment-" +
                                                                                payment.value,
                                                                              name: "paymentOption",
                                                                              type: "radio",
                                                                              disabled:
                                                                                payment.disabled,
                                                                            },
                                                                          domProps:
                                                                            {
                                                                              value:
                                                                                payment.value,
                                                                              checked:
                                                                                _vm._q(
                                                                                  _vm
                                                                                    .personalizationDTO
                                                                                    .paymentOption,
                                                                                  payment.value
                                                                                ),
                                                                            },
                                                                          on: {
                                                                            change:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                return _vm.$set(
                                                                                  _vm.personalizationDTO,
                                                                                  "paymentOption",
                                                                                  payment.value
                                                                                )
                                                                              },
                                                                          },
                                                                        }
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "radio__checkMark",
                                                                        }
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        {}
                                                                      ),
                                                                      _vm._v(
                                                                        "\n                            " +
                                                                          _vm._s(
                                                                            payment.text
                                                                          ) +
                                                                          "\n                          "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "option__images",
                                                            },
                                                            [
                                                              payment.value ===
                                                              "creditcard"
                                                                ? [
                                                                    _c("img", {
                                                                      staticClass:
                                                                        "mastercard",
                                                                      attrs: {
                                                                        src: "https://www.messe-stuttgart.de/fileadmin/media/mts/payment/mastercard.png",
                                                                        alt: "mastercard",
                                                                      },
                                                                    }),
                                                                    _vm._v(" "),
                                                                    _c("img", {
                                                                      staticClass:
                                                                        "visa",
                                                                      attrs: {
                                                                        src: "https://www.messe-stuttgart.de/fileadmin/media/mts/payment/visa.png",
                                                                        alt: "visa",
                                                                      },
                                                                    }),
                                                                  ]
                                                                : payment.value ===
                                                                  "paypal"
                                                                ? [
                                                                    _c("img", {
                                                                      staticClass:
                                                                        "paypal",
                                                                      attrs: {
                                                                        src: "https://www.messe-stuttgart.de/fileadmin/media/mts/payment/paypal.png",
                                                                        alt: "PayPal",
                                                                      },
                                                                    }),
                                                                  ]
                                                                : payment.value ===
                                                                  "sepa"
                                                                ? [
                                                                    _c("img", {
                                                                      staticClass:
                                                                        "paypal",
                                                                      attrs: {
                                                                        src: "https://www.messe-stuttgart.de/fileadmin/media/mts/payment/SepaLogo.svg",
                                                                        alt: "SEPA",
                                                                      },
                                                                    }),
                                                                  ]
                                                                : payment.value ===
                                                                  "paydirekt"
                                                                ? [
                                                                    _c("img", {
                                                                      staticClass:
                                                                        "giropay paypal",
                                                                      attrs: {
                                                                        src: "https://www.messe-stuttgart.de/fileadmin/media/mts/payment/paydirekt.svg",
                                                                        als: "paydirekt",
                                                                      },
                                                                    }),
                                                                  ]
                                                                : _vm._e(),
                                                            ],
                                                            2
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.paymentInfoDTO &&
                                                      _vm.paymentInfoForm &&
                                                      payment.value ===
                                                        _vm.personalizationDTO
                                                          .paymentOption
                                                        ? [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "option__form",
                                                              },
                                                              [
                                                                _c("h3", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "checkout.payment.headline"
                                                                      )
                                                                    )
                                                                  ),
                                                                ]),
                                                                _vm._v(" "),
                                                                _c(
                                                                  _vm.paymentInfoForm,
                                                                  {
                                                                    tag: "component",
                                                                    attrs: {
                                                                      dto: _vm.paymentInfoDTO,
                                                                      submittedPaymentFormProp:
                                                                        _vm.submittedPaymentForm,
                                                                    },
                                                                    on: {
                                                                      submittedPaymentFormEmit:
                                                                        function (
                                                                          paymentForm
                                                                        ) {
                                                                          return (_vm.submittedPaymentForm =
                                                                            paymentForm)
                                                                        },
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        : _vm._e(),
                                                    ],
                                                    2
                                                  )
                                                : _vm._e(),
                                            ]
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "checkout-form__group" },
                                      [_c("hr")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "form__group form__group--checkbox",
                                      },
                                      [
                                        _c("p", [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.$t(
                                                  "checkout.payment.invoiceAddressQuestion"
                                                )
                                              ) +
                                              "\n                "
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          { staticClass: "form__label" },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.personalizationDTO
                                                      .useInvoiceAddress,
                                                  expression:
                                                    "personalizationDTO.useInvoiceAddress",
                                                },
                                              ],
                                              attrs: {
                                                id: "invoiceAddress",
                                                name: "invoiceAddress",
                                                type: "checkbox",
                                              },
                                              domProps: {
                                                value: false,
                                                checked: Array.isArray(
                                                  _vm.personalizationDTO
                                                    .useInvoiceAddress
                                                )
                                                  ? _vm._i(
                                                      _vm.personalizationDTO
                                                        .useInvoiceAddress,
                                                      false
                                                    ) > -1
                                                  : _vm.personalizationDTO
                                                      .useInvoiceAddress,
                                              },
                                              on: {
                                                change: function ($event) {
                                                  var $$a =
                                                      _vm.personalizationDTO
                                                        .useInvoiceAddress,
                                                    $$el = $event.target,
                                                    $$c = $$el.checked
                                                      ? true
                                                      : false
                                                  if (Array.isArray($$a)) {
                                                    var $$v = false,
                                                      $$i = _vm._i($$a, $$v)
                                                    if ($$el.checked) {
                                                      $$i < 0 &&
                                                        _vm.$set(
                                                          _vm.personalizationDTO,
                                                          "useInvoiceAddress",
                                                          $$a.concat([$$v])
                                                        )
                                                    } else {
                                                      $$i > -1 &&
                                                        _vm.$set(
                                                          _vm.personalizationDTO,
                                                          "useInvoiceAddress",
                                                          $$a
                                                            .slice(0, $$i)
                                                            .concat(
                                                              $$a.slice($$i + 1)
                                                            )
                                                        )
                                                    }
                                                  } else {
                                                    _vm.$set(
                                                      _vm.personalizationDTO,
                                                      "useInvoiceAddress",
                                                      $$c
                                                    )
                                                  }
                                                },
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("span", {
                                              staticClass:
                                                "checkbox-label icon icon-check",
                                            }),
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "checkout.payment.invoiceAddress"
                                                  )
                                                ) +
                                                "\n                "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.personalizationDTO.useInvoiceAddress
                                      ? [
                                          _c("customer-form", {
                                            key: "invoice",
                                            ref: "invoiceForm",
                                            attrs: {
                                              context: "invoice",
                                              "customer-data-d-t-o":
                                                _vm.invoiceDataDTO,
                                              "inventory-url": _vm.inventoryUrl,
                                              "show-errors":
                                                _vm.showPaymentErrors,
                                              "required-fields": [
                                                "salutation",
                                                "firstName",
                                                "lastName",
                                                "street",
                                                "houseNr",
                                                "zip",
                                                "city",
                                                "country",
                                                "addressType",
                                                "company",
                                              ],
                                            },
                                            on: {
                                              update: _vm.updatePaymentDataDTO,
                                            },
                                          }),
                                        ]
                                      : _vm._e(),
                                  ],
                                  2
                                ),
                              ]
                            : [
                                _c("p", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("checkout.payment.noPaymentData")
                                    )
                                  ),
                                ]),
                              ],
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "tab-content",
                        {
                          attrs: {
                            "before-change": _vm.processCheckout,
                            title: _vm.$t("checkout.check.title"),
                          },
                        },
                        [
                          _c("h2", [
                            _vm._v(_vm._s(_vm.$t("checkout.check.headline"))),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "checkout-form__container" },
                            [
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !_vm.checkoutValid,
                                      expression: "!checkoutValid",
                                    },
                                  ],
                                  staticClass: "checkout-form__error",
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t(
                                          "global.errorMessages.unfinishedForm"
                                        )
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "checkout__check-data" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "section" },
                                    [
                                      _c("h3", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "checkout.check.addresses.orderer"
                                            )
                                          )
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("customer-data", {
                                        key: "personalization",
                                        attrs: {
                                          countries: _vm.countries,
                                          "customer-data-d-t-o":
                                            _vm.personalizationDTO,
                                          states: _vm.states,
                                          titles: _vm.titles,
                                        },
                                      }),
                                      _vm._v(" "),
                                      !_vm.isSubmitting
                                        ? [
                                            _c(
                                              "a",
                                              {
                                                attrs: { href: "#" },
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    $event.preventDefault()
                                                    return _vm.toStep(
                                                      _vm.personalizationStep
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "global.links.update"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "checkout-form__group" },
                                    [_c("hr", { staticClass: "vertical" })]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "section" },
                                    [
                                      _c("h3", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "checkout.check.addresses.invoice"
                                            )
                                          )
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _vm.personalizationDTO.useInvoiceAddress
                                        ? [
                                            _c("customer-data", {
                                              key: "invoice",
                                              attrs: {
                                                countries: _vm.countries,
                                                "customer-data-d-t-o":
                                                  _vm.invoiceDataDTO,
                                                "is-billing": true,
                                                states: _vm.states,
                                                titles: _vm.titles,
                                              },
                                            }),
                                          ]
                                        : [
                                            _c("customer-data", {
                                              key: "personalization",
                                              attrs: {
                                                countries: _vm.countries,
                                                "customer-data-d-t-o":
                                                  _vm.personalizationDTO,
                                                "is-billing": true,
                                                states: _vm.states,
                                                titles: _vm.titles,
                                              },
                                            }),
                                          ],
                                      _vm._v(" "),
                                      !_vm.isSubmitting
                                        ? [
                                            _c(
                                              "a",
                                              {
                                                attrs: { href: "#" },
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    $event.preventDefault()
                                                    return _vm.toStep(
                                                      _vm.paymentStep
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "global.links.update"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "checkout-form__group" },
                                    [_c("hr", { staticClass: "vertical" })]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "section" },
                                    [
                                      _c("h3", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "checkout.check.paymentMethod"
                                            )
                                          )
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _vm.personalizationDTO.paymentOption &&
                                      _vm.cart.sum > 0
                                        ? [
                                            _c("payment-type", {
                                              attrs: {
                                                "payment-type":
                                                  _vm.personalizationDTO
                                                    .paymentOption,
                                              },
                                            }),
                                          ]
                                        : [
                                            _c("p", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "checkout.check.noPaymentMethod"
                                                  )
                                                )
                                              ),
                                            ]),
                                          ],
                                      _vm._v(" "),
                                      !_vm.isSubmitting
                                        ? [
                                            _c(
                                              "a",
                                              {
                                                attrs: { href: "#" },
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    $event.preventDefault()
                                                    return _vm.toStep(
                                                      _vm.paymentStep
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "global.links.update"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "checkout-form__group checkout-form__group--hiddenMobile",
                                },
                                [_c("hr")]
                              ),
                              _vm._v(" "),
                              _c("cart-view", {
                                attrs: {
                                  "inventory-url": _vm.inventoryUrl,
                                  language: _vm.userLanguage,
                                  "allow-code-input": false,
                                  "checkout-view": true,
                                  "login-page-url": _vm.loginPageUrl,
                                  "ticket-shop-url": _vm.ticketShopUrl,
                                  "ticket-checkout-url": _vm.checkoutUrl,
                                  readonly: _vm.isSubmitting,
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "checkout-form__group checkout-form__group--hiddenMobile",
                                },
                                [_c("hr")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "checkout-form__group privacyStatement",
                                },
                                [
                                  _vm.clientsWithConsentExist
                                    ? [
                                        _vm._l(
                                          _vm.clientsWithConsent,
                                          function (client, idx) {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  key: client.id,
                                                  staticClass:
                                                    "client-agb-privacy",
                                                },
                                                [
                                                  _c("h4", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "privacy.headlineClient",
                                                          {
                                                            eventsTitle:
                                                              _vm.eventConsentString(
                                                                client.id
                                                              ),
                                                          }
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _vm.additionalNotices[
                                                    "" + client.id
                                                  ]
                                                    ? [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "checkout__additional-notices-container",
                                                          },
                                                          [
                                                            _c("div", {
                                                              staticClass:
                                                                "additional-notice",
                                                              domProps: {
                                                                innerHTML:
                                                                  _vm._s(
                                                                    _vm.additionalNoticeHtmlFor(
                                                                      client.id
                                                                    )
                                                                  ),
                                                              },
                                                            }),
                                                          ]
                                                        ),
                                                      ]
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.privacyStatements[
                                                    "" + client.id
                                                  ]
                                                    ? [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "form__group form__group--checkbox",
                                                            class: {
                                                              "form__field--error":
                                                                _vm.showPrivacyErrors &&
                                                                !_vm.acceptedClientsPrivacyStatements,
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "label",
                                                              {
                                                                staticClass:
                                                                  "form__label",
                                                                attrs: {
                                                                  for:
                                                                    "privacy-" +
                                                                    client.id,
                                                                },
                                                              },
                                                              [
                                                                _c("input", {
                                                                  directives: [
                                                                    {
                                                                      name: "model",
                                                                      rawName:
                                                                        "v-model",
                                                                      value:
                                                                        _vm
                                                                          .personalizationDTO
                                                                          .privacyStatements,
                                                                      expression:
                                                                        "personalizationDTO.privacyStatements",
                                                                    },
                                                                  ],
                                                                  attrs: {
                                                                    id:
                                                                      "privacy-" +
                                                                      client.id,
                                                                    disabled:
                                                                      _vm.isSubmitting,
                                                                    name: "privacy",
                                                                    required:
                                                                      "",
                                                                    type: "checkbox",
                                                                  },
                                                                  domProps: {
                                                                    value:
                                                                      _vm
                                                                        .privacyStatements[
                                                                        "" +
                                                                          client.id
                                                                      ].id,
                                                                    checked:
                                                                      Array.isArray(
                                                                        _vm
                                                                          .personalizationDTO
                                                                          .privacyStatements
                                                                      )
                                                                        ? _vm._i(
                                                                            _vm
                                                                              .personalizationDTO
                                                                              .privacyStatements,
                                                                            _vm
                                                                              .privacyStatements[
                                                                              "" +
                                                                                client.id
                                                                            ].id
                                                                          ) > -1
                                                                        : _vm
                                                                            .personalizationDTO
                                                                            .privacyStatements,
                                                                  },
                                                                  on: {
                                                                    change:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        var $$a =
                                                                            _vm
                                                                              .personalizationDTO
                                                                              .privacyStatements,
                                                                          $$el =
                                                                            $event.target,
                                                                          $$c =
                                                                            $$el.checked
                                                                              ? true
                                                                              : false
                                                                        if (
                                                                          Array.isArray(
                                                                            $$a
                                                                          )
                                                                        ) {
                                                                          var $$v =
                                                                              _vm
                                                                                .privacyStatements[
                                                                                "" +
                                                                                  client.id
                                                                              ]
                                                                                .id,
                                                                            $$i =
                                                                              _vm._i(
                                                                                $$a,
                                                                                $$v
                                                                              )
                                                                          if (
                                                                            $$el.checked
                                                                          ) {
                                                                            $$i <
                                                                              0 &&
                                                                              _vm.$set(
                                                                                _vm.personalizationDTO,
                                                                                "privacyStatements",
                                                                                $$a.concat(
                                                                                  [
                                                                                    $$v,
                                                                                  ]
                                                                                )
                                                                              )
                                                                          } else {
                                                                            $$i >
                                                                              -1 &&
                                                                              _vm.$set(
                                                                                _vm.personalizationDTO,
                                                                                "privacyStatements",
                                                                                $$a
                                                                                  .slice(
                                                                                    0,
                                                                                    $$i
                                                                                  )
                                                                                  .concat(
                                                                                    $$a.slice(
                                                                                      $$i +
                                                                                        1
                                                                                    )
                                                                                  )
                                                                              )
                                                                          }
                                                                        } else {
                                                                          _vm.$set(
                                                                            _vm.personalizationDTO,
                                                                            "privacyStatements",
                                                                            $$c
                                                                          )
                                                                        }
                                                                      },
                                                                  },
                                                                }),
                                                                _vm._v(" "),
                                                                _c("span", {
                                                                  staticClass:
                                                                    "checkbox-label icon icon-check",
                                                                }),
                                                                _vm._v(
                                                                  "\n                          " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "privacy.client.privacyStatement1"
                                                                      )
                                                                    ) +
                                                                    "\n                          "
                                                                ),
                                                                _c(
                                                                  "a",
                                                                  {
                                                                    staticClass:
                                                                      "inline-link privacyStatement-link",
                                                                    attrs: {
                                                                      href: "#",
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          $event.stopPropagation()
                                                                          $event.preventDefault()
                                                                          return _vm.openPrivacyModal(
                                                                            client
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                            " +
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "privacy.client.privacyStatement2"
                                                                          )
                                                                        )
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(
                                                                  "\n                          " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "privacy.client.privacyStatement3"
                                                                      )
                                                                    ) +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "global.forms.required"
                                                                      )
                                                                    ) +
                                                                    "\n                        "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    : [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "form__group form__group--checkbox",
                                                            class: {
                                                              "form__field--error":
                                                                _vm.showPrivacyErrors &&
                                                                !_vm
                                                                  .personalizationDTO
                                                                  .fallbackPrivacyChecked,
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "label",
                                                              {
                                                                staticClass:
                                                                  "form__label",
                                                                attrs: {
                                                                  for: "privacy-fallback",
                                                                },
                                                              },
                                                              [
                                                                _c("input", {
                                                                  directives: [
                                                                    {
                                                                      name: "model",
                                                                      rawName:
                                                                        "v-model",
                                                                      value:
                                                                        _vm
                                                                          .personalizationDTO
                                                                          .fallbackPrivacyChecked,
                                                                      expression:
                                                                        "personalizationDTO.fallbackPrivacyChecked",
                                                                    },
                                                                  ],
                                                                  attrs: {
                                                                    id: "privacy-fallback",
                                                                    name: "privacy",
                                                                    required:
                                                                      "",
                                                                    type: "checkbox",
                                                                    disabled:
                                                                      _vm.isSubmitting,
                                                                  },
                                                                  domProps: {
                                                                    checked:
                                                                      Array.isArray(
                                                                        _vm
                                                                          .personalizationDTO
                                                                          .fallbackPrivacyChecked
                                                                      )
                                                                        ? _vm._i(
                                                                            _vm
                                                                              .personalizationDTO
                                                                              .fallbackPrivacyChecked,
                                                                            null
                                                                          ) > -1
                                                                        : _vm
                                                                            .personalizationDTO
                                                                            .fallbackPrivacyChecked,
                                                                  },
                                                                  on: {
                                                                    change:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        var $$a =
                                                                            _vm
                                                                              .personalizationDTO
                                                                              .fallbackPrivacyChecked,
                                                                          $$el =
                                                                            $event.target,
                                                                          $$c =
                                                                            $$el.checked
                                                                              ? true
                                                                              : false
                                                                        if (
                                                                          Array.isArray(
                                                                            $$a
                                                                          )
                                                                        ) {
                                                                          var $$v =
                                                                              null,
                                                                            $$i =
                                                                              _vm._i(
                                                                                $$a,
                                                                                $$v
                                                                              )
                                                                          if (
                                                                            $$el.checked
                                                                          ) {
                                                                            $$i <
                                                                              0 &&
                                                                              _vm.$set(
                                                                                _vm.personalizationDTO,
                                                                                "fallbackPrivacyChecked",
                                                                                $$a.concat(
                                                                                  [
                                                                                    $$v,
                                                                                  ]
                                                                                )
                                                                              )
                                                                          } else {
                                                                            $$i >
                                                                              -1 &&
                                                                              _vm.$set(
                                                                                _vm.personalizationDTO,
                                                                                "fallbackPrivacyChecked",
                                                                                $$a
                                                                                  .slice(
                                                                                    0,
                                                                                    $$i
                                                                                  )
                                                                                  .concat(
                                                                                    $$a.slice(
                                                                                      $$i +
                                                                                        1
                                                                                    )
                                                                                  )
                                                                              )
                                                                          }
                                                                        } else {
                                                                          _vm.$set(
                                                                            _vm.personalizationDTO,
                                                                            "fallbackPrivacyChecked",
                                                                            $$c
                                                                          )
                                                                        }
                                                                      },
                                                                  },
                                                                }),
                                                                _vm._v(" "),
                                                                _c("span", {
                                                                  staticClass:
                                                                    "checkbox-label icon icon-check",
                                                                }),
                                                                _vm._v(
                                                                  "\n                          " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "privacy.client.privacyStatement1"
                                                                      )
                                                                    ) +
                                                                    "\n                          "
                                                                ),
                                                                _c(
                                                                  "a",
                                                                  {
                                                                    staticClass:
                                                                      "inline-link privacyStatement-link",
                                                                    attrs: {
                                                                      target:
                                                                        "_blank",
                                                                      href: _vm.i18nPrivacyStatementLink,
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                            " +
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "privacy.client.privacyStatement2"
                                                                          )
                                                                        )
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(
                                                                  "\n                          " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "privacy.client.privacyStatement3"
                                                                      )
                                                                    ) +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "global.forms.required"
                                                                      )
                                                                    ) +
                                                                    "\n                        "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                  _vm._v(" "),
                                                  _vm.agb["" + client.id]
                                                    ? [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "form__group form__group--checkbox",
                                                            class: {
                                                              "form__field--error":
                                                                _vm.showPrivacyErrors &&
                                                                !_vm.acceptedClientsAGB,
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "label",
                                                              {
                                                                staticClass:
                                                                  "form__label",
                                                                attrs: {
                                                                  for:
                                                                    "agb-" +
                                                                    client.id,
                                                                },
                                                              },
                                                              [
                                                                _c("input", {
                                                                  directives: [
                                                                    {
                                                                      name: "model",
                                                                      rawName:
                                                                        "v-model",
                                                                      value:
                                                                        _vm
                                                                          .personalizationDTO
                                                                          .termsAndConditions,
                                                                      expression:
                                                                        "personalizationDTO.termsAndConditions",
                                                                    },
                                                                  ],
                                                                  attrs: {
                                                                    id:
                                                                      "agb-" +
                                                                      client.id,
                                                                    disabled:
                                                                      _vm.isSubmitting,
                                                                    name: "agb",
                                                                    required:
                                                                      "",
                                                                    type: "checkbox",
                                                                  },
                                                                  domProps: {
                                                                    value:
                                                                      _vm.agb[
                                                                        "" +
                                                                          client.id
                                                                      ].id,
                                                                    checked:
                                                                      Array.isArray(
                                                                        _vm
                                                                          .personalizationDTO
                                                                          .termsAndConditions
                                                                      )
                                                                        ? _vm._i(
                                                                            _vm
                                                                              .personalizationDTO
                                                                              .termsAndConditions,
                                                                            _vm
                                                                              .agb[
                                                                              "" +
                                                                                client.id
                                                                            ].id
                                                                          ) > -1
                                                                        : _vm
                                                                            .personalizationDTO
                                                                            .termsAndConditions,
                                                                  },
                                                                  on: {
                                                                    change:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        var $$a =
                                                                            _vm
                                                                              .personalizationDTO
                                                                              .termsAndConditions,
                                                                          $$el =
                                                                            $event.target,
                                                                          $$c =
                                                                            $$el.checked
                                                                              ? true
                                                                              : false
                                                                        if (
                                                                          Array.isArray(
                                                                            $$a
                                                                          )
                                                                        ) {
                                                                          var $$v =
                                                                              _vm
                                                                                .agb[
                                                                                "" +
                                                                                  client.id
                                                                              ]
                                                                                .id,
                                                                            $$i =
                                                                              _vm._i(
                                                                                $$a,
                                                                                $$v
                                                                              )
                                                                          if (
                                                                            $$el.checked
                                                                          ) {
                                                                            $$i <
                                                                              0 &&
                                                                              _vm.$set(
                                                                                _vm.personalizationDTO,
                                                                                "termsAndConditions",
                                                                                $$a.concat(
                                                                                  [
                                                                                    $$v,
                                                                                  ]
                                                                                )
                                                                              )
                                                                          } else {
                                                                            $$i >
                                                                              -1 &&
                                                                              _vm.$set(
                                                                                _vm.personalizationDTO,
                                                                                "termsAndConditions",
                                                                                $$a
                                                                                  .slice(
                                                                                    0,
                                                                                    $$i
                                                                                  )
                                                                                  .concat(
                                                                                    $$a.slice(
                                                                                      $$i +
                                                                                        1
                                                                                    )
                                                                                  )
                                                                              )
                                                                          }
                                                                        } else {
                                                                          _vm.$set(
                                                                            _vm.personalizationDTO,
                                                                            "termsAndConditions",
                                                                            $$c
                                                                          )
                                                                        }
                                                                      },
                                                                  },
                                                                }),
                                                                _vm._v(" "),
                                                                _c("span", {
                                                                  staticClass:
                                                                    "checkbox-label icon icon-check",
                                                                }),
                                                                _vm._v(
                                                                  "\n                          " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "privacy.agb.iAccept"
                                                                      )
                                                                    ) +
                                                                    "\n                          "
                                                                ),
                                                                _c(
                                                                  "a",
                                                                  {
                                                                    staticClass:
                                                                      "inline-link privacyStatement-link",
                                                                    attrs: {
                                                                      href: "#",
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          $event.stopPropagation()
                                                                          $event.preventDefault()
                                                                          return _vm.openAGBModal(
                                                                            client
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                            " +
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "privacy.agb.agbOf"
                                                                          )
                                                                        ) +
                                                                        "\n                          "
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(
                                                                  "\n                          " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "global.forms.required"
                                                                      )
                                                                    ) +
                                                                    "\n                        "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    : [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "form__group form__group--checkbox",
                                                            class: {
                                                              "form__field--error":
                                                                _vm.showPrivacyErrors &&
                                                                !_vm
                                                                  .personalizationDTO
                                                                  .fallbackAgbChecked,
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "label",
                                                              {
                                                                staticClass:
                                                                  "form__label",
                                                                attrs: {
                                                                  for: "agb-fallback",
                                                                },
                                                              },
                                                              [
                                                                _c("input", {
                                                                  directives: [
                                                                    {
                                                                      name: "model",
                                                                      rawName:
                                                                        "v-model",
                                                                      value:
                                                                        _vm
                                                                          .personalizationDTO
                                                                          .fallbackAgbChecked,
                                                                      expression:
                                                                        "personalizationDTO.fallbackAgbChecked",
                                                                    },
                                                                  ],
                                                                  attrs: {
                                                                    id: "agb-fallback",
                                                                    name: "agb",
                                                                    required:
                                                                      "",
                                                                    type: "checkbox",
                                                                    disabled:
                                                                      _vm.isSubmitting,
                                                                  },
                                                                  domProps: {
                                                                    checked:
                                                                      Array.isArray(
                                                                        _vm
                                                                          .personalizationDTO
                                                                          .fallbackAgbChecked
                                                                      )
                                                                        ? _vm._i(
                                                                            _vm
                                                                              .personalizationDTO
                                                                              .fallbackAgbChecked,
                                                                            null
                                                                          ) > -1
                                                                        : _vm
                                                                            .personalizationDTO
                                                                            .fallbackAgbChecked,
                                                                  },
                                                                  on: {
                                                                    change:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        var $$a =
                                                                            _vm
                                                                              .personalizationDTO
                                                                              .fallbackAgbChecked,
                                                                          $$el =
                                                                            $event.target,
                                                                          $$c =
                                                                            $$el.checked
                                                                              ? true
                                                                              : false
                                                                        if (
                                                                          Array.isArray(
                                                                            $$a
                                                                          )
                                                                        ) {
                                                                          var $$v =
                                                                              null,
                                                                            $$i =
                                                                              _vm._i(
                                                                                $$a,
                                                                                $$v
                                                                              )
                                                                          if (
                                                                            $$el.checked
                                                                          ) {
                                                                            $$i <
                                                                              0 &&
                                                                              _vm.$set(
                                                                                _vm.personalizationDTO,
                                                                                "fallbackAgbChecked",
                                                                                $$a.concat(
                                                                                  [
                                                                                    $$v,
                                                                                  ]
                                                                                )
                                                                              )
                                                                          } else {
                                                                            $$i >
                                                                              -1 &&
                                                                              _vm.$set(
                                                                                _vm.personalizationDTO,
                                                                                "fallbackAgbChecked",
                                                                                $$a
                                                                                  .slice(
                                                                                    0,
                                                                                    $$i
                                                                                  )
                                                                                  .concat(
                                                                                    $$a.slice(
                                                                                      $$i +
                                                                                        1
                                                                                    )
                                                                                  )
                                                                              )
                                                                          }
                                                                        } else {
                                                                          _vm.$set(
                                                                            _vm.personalizationDTO,
                                                                            "fallbackAgbChecked",
                                                                            $$c
                                                                          )
                                                                        }
                                                                      },
                                                                  },
                                                                }),
                                                                _vm._v(" "),
                                                                _c("span", {
                                                                  staticClass:
                                                                    "checkbox-label icon icon-check",
                                                                }),
                                                                _vm._v(
                                                                  "\n                          " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "privacy.agb.iAccept"
                                                                      )
                                                                    ) +
                                                                    "\n                          "
                                                                ),
                                                                _c(
                                                                  "a",
                                                                  {
                                                                    staticClass:
                                                                      "privacyStatement-link",
                                                                    attrs: {
                                                                      target:
                                                                        "_blank",
                                                                      href: _vm.i18nTermsAndConditionsLink,
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                            " +
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "privacy.agb.agbOf"
                                                                          )
                                                                        )
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(
                                                                  "\n                          " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "global.forms.required"
                                                                      )
                                                                    ) +
                                                                    "\n                        "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                  _vm._v(" "),
                                                  idx <
                                                  _vm.clientsWithConsent
                                                    .length -
                                                    1
                                                    ? [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "checkout-form__group",
                                                          },
                                                          [_c("hr")]
                                                        ),
                                                      ]
                                                    : _vm._e(),
                                                ],
                                                2
                                              ),
                                            ]
                                          }
                                        ),
                                      ]
                                    : [
                                        _vm.fallbackAdditionalNoticeHtml
                                          ? [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "checkout__additional-notices-container",
                                                },
                                                [
                                                  _c("div", {
                                                    staticClass:
                                                      "additional-notice",
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.fallbackAdditionalNoticeHtml
                                                      ),
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ]
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "form__group form__group--checkbox",
                                            class: {
                                              "form__field--error":
                                                _vm.showPrivacyErrors &&
                                                !_vm.personalizationDTO
                                                  .fallbackPrivacyChecked,
                                            },
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass: "form__label",
                                                attrs: {
                                                  for: "privacy-fallback",
                                                },
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.personalizationDTO
                                                          .fallbackPrivacyChecked,
                                                      expression:
                                                        "personalizationDTO.fallbackPrivacyChecked",
                                                    },
                                                  ],
                                                  attrs: {
                                                    id: "privacy-fallback",
                                                    name: "privacy",
                                                    required: "",
                                                    type: "checkbox",
                                                    disabled: _vm.isSubmitting,
                                                  },
                                                  domProps: {
                                                    checked: Array.isArray(
                                                      _vm.personalizationDTO
                                                        .fallbackPrivacyChecked
                                                    )
                                                      ? _vm._i(
                                                          _vm.personalizationDTO
                                                            .fallbackPrivacyChecked,
                                                          null
                                                        ) > -1
                                                      : _vm.personalizationDTO
                                                          .fallbackPrivacyChecked,
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      var $$a =
                                                          _vm.personalizationDTO
                                                            .fallbackPrivacyChecked,
                                                        $$el = $event.target,
                                                        $$c = $$el.checked
                                                          ? true
                                                          : false
                                                      if (Array.isArray($$a)) {
                                                        var $$v = null,
                                                          $$i = _vm._i($$a, $$v)
                                                        if ($$el.checked) {
                                                          $$i < 0 &&
                                                            _vm.$set(
                                                              _vm.personalizationDTO,
                                                              "fallbackPrivacyChecked",
                                                              $$a.concat([$$v])
                                                            )
                                                        } else {
                                                          $$i > -1 &&
                                                            _vm.$set(
                                                              _vm.personalizationDTO,
                                                              "fallbackPrivacyChecked",
                                                              $$a
                                                                .slice(0, $$i)
                                                                .concat(
                                                                  $$a.slice(
                                                                    $$i + 1
                                                                  )
                                                                )
                                                            )
                                                        }
                                                      } else {
                                                        _vm.$set(
                                                          _vm.personalizationDTO,
                                                          "fallbackPrivacyChecked",
                                                          $$c
                                                        )
                                                      }
                                                    },
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass:
                                                    "checkbox-label icon icon-check",
                                                }),
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "privacy.client.privacyStatement1"
                                                      )
                                                    ) +
                                                    "\n                    "
                                                ),
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "inline-link privacyStatement-link",
                                                    attrs: {
                                                      target: "_blank",
                                                      href: "https://www.messe-stuttgart.de/datenschutzerklaerung/",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "privacy.client.privacyStatement2"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "privacy.client.privacyStatement3"
                                                      )
                                                    ) +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "global.forms.required"
                                                      )
                                                    ) +
                                                    "\n                  "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "form__group form__group--checkbox",
                                            class: {
                                              "form__field--error":
                                                _vm.showPrivacyErrors &&
                                                !_vm.personalizationDTO
                                                  .fallbackAgbChecked,
                                            },
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass: "form__label",
                                                attrs: { for: "agb-fallback" },
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.personalizationDTO
                                                          .fallbackAgbChecked,
                                                      expression:
                                                        "personalizationDTO.fallbackAgbChecked",
                                                    },
                                                  ],
                                                  attrs: {
                                                    id: "agb-fallback",
                                                    name: "agb",
                                                    required: "",
                                                    type: "checkbox",
                                                    disabled: _vm.isSubmitting,
                                                  },
                                                  domProps: {
                                                    checked: Array.isArray(
                                                      _vm.personalizationDTO
                                                        .fallbackAgbChecked
                                                    )
                                                      ? _vm._i(
                                                          _vm.personalizationDTO
                                                            .fallbackAgbChecked,
                                                          null
                                                        ) > -1
                                                      : _vm.personalizationDTO
                                                          .fallbackAgbChecked,
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      var $$a =
                                                          _vm.personalizationDTO
                                                            .fallbackAgbChecked,
                                                        $$el = $event.target,
                                                        $$c = $$el.checked
                                                          ? true
                                                          : false
                                                      if (Array.isArray($$a)) {
                                                        var $$v = null,
                                                          $$i = _vm._i($$a, $$v)
                                                        if ($$el.checked) {
                                                          $$i < 0 &&
                                                            _vm.$set(
                                                              _vm.personalizationDTO,
                                                              "fallbackAgbChecked",
                                                              $$a.concat([$$v])
                                                            )
                                                        } else {
                                                          $$i > -1 &&
                                                            _vm.$set(
                                                              _vm.personalizationDTO,
                                                              "fallbackAgbChecked",
                                                              $$a
                                                                .slice(0, $$i)
                                                                .concat(
                                                                  $$a.slice(
                                                                    $$i + 1
                                                                  )
                                                                )
                                                            )
                                                        }
                                                      } else {
                                                        _vm.$set(
                                                          _vm.personalizationDTO,
                                                          "fallbackAgbChecked",
                                                          $$c
                                                        )
                                                      }
                                                    },
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass:
                                                    "checkbox-label icon icon-check",
                                                }),
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "privacy.agb.iAccept"
                                                      )
                                                    ) +
                                                    "\n                    "
                                                ),
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "privacyStatement-link",
                                                    attrs: {
                                                      target: "_blank",
                                                      href: "https://www.messe-stuttgart.de/agb/",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "privacy.agb.agbOf"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "global.forms.required"
                                                      )
                                                    ) +
                                                    "\n                  "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ],
                                  _vm._v(" "),
                                  _c(
                                    "Modal",
                                    { ref: "privacyModal" },
                                    [
                                      _c(
                                        "template",
                                        { slot: "content" },
                                        [
                                          _vm.selectedPrivacyStatement &&
                                          _vm.i18nPrivacyStatementContent
                                            ? [
                                                _c("div", {
                                                  staticClass: "privacyModal",
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      _vm.i18nPrivacyStatementContent
                                                    ),
                                                  },
                                                }),
                                              ]
                                            : _vm._e(),
                                        ],
                                        2
                                      ),
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "Modal",
                                    { ref: "agbModal" },
                                    [
                                      _c(
                                        "template",
                                        { slot: "content" },
                                        [
                                          _vm.selectedAGB &&
                                          _vm.i18nTermsAndConditionsContent
                                            ? [
                                                _c("div", {
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      _vm.i18nTermsAndConditionsContent
                                                    ),
                                                  },
                                                }),
                                              ]
                                            : _vm._e(),
                                        ],
                                        2
                                      ),
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "Modal",
                                    { ref: "consentModal" },
                                    [
                                      _c("template", { slot: "content" }, [
                                        _c("h3", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "global.paypal.consentNeeded"
                                              )
                                            )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("p", {
                                          staticStyle: { "margin-top": "10px" },
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.$t(
                                                "global.paypal.userCentricsForbidden"
                                              )
                                            ),
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "consent-modal-buttons",
                                          },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass: "button",
                                                on: {
                                                  click:
                                                    _vm.closeUcPayPalInformation,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "global.paypal.toPayment"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "button",
                                              {
                                                staticClass: "button",
                                                on: {
                                                  click:
                                                    _vm.showUcPayPalInformation,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "global.paypal.showInformation"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "button button-inverted button-right",
                                                on: {
                                                  click:
                                                    _vm.acceptPayPalConsent,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "global.paypal.acceptPayPal"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ],
                                    2
                                  ),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "tab-content",
                        { attrs: { title: _vm.$t("checkout.finished.title") } },
                        [
                          _c("h3", [
                            _vm._v(_vm._s(_vm.$t("checkout.finished.thanks"))),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }